import { FC } from 'react'

import UserProfileInfo from '@/components/entities/user/ui/UserProfileInfo'
import { CardSkeleton } from '@/components/shared/skeleton'

import UserContactFooter from './UserContactFooter'

type Props = {
  contentHeight: string
  setFooterRef: (ref: HTMLElement | null) => void
}

const UserContactSkeleton: FC<Props> = ({ contentHeight, setFooterRef }) => {
  const infoItems = Array.from({ length: 5 }).map((_, index) => ({
    key: index,
    value: (
      <CardSkeleton className="h-[28px] w-[200px] rounded-24 lg:h-[24px]" />
    )
  }))

  return (
    <>
      <div
        className="overflow-y-auto px-40 lg:px-24 sm:px-16"
        style={{ height: contentHeight }}
      >
        <UserProfileInfo infoItems={infoItems} className="mt-16 lg:mt-0" />

        <CardSkeleton className="my-40 h-[320px] rounded-24 p-16 lg:my-20 sm:h-[210px] sm:p-12" />
      </div>

      <UserContactFooter setFooterRef={setFooterRef}>
        <CardSkeleton className="h-[56px] w-full rounded-24 sm:h-[44px]" />
      </UserContactFooter>
    </>
  )
}

export default UserContactSkeleton
